import CustomCard from '../../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import styles from '../../../styles/components/register.module.scss'
import { useFormContext } from 'react-hook-form'

export const CommunicationData = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const requiredMsg = 'Dieses Feld ist ein Pflichtfeld'
  const emailErrorMsg = 'Ungültige E-Mail Adresse.'

  return (
    <CustomCard header="Kommunikationsdaten">
      <div className="formRow">
        <TextBoxComponent placeholder="Telefon" floatLabelType="Always" {...register('adrPhone')} />
        <div>
          <TextBoxComponent placeholder="E-Mail" cssClass={`${styles.required}`} floatLabelType="Always" {...register('contactEMail', { required: requiredMsg, pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: emailErrorMsg } })} />
          <p className="errorMsg">{(errors.contactEMail?.message as string) || null}</p>
        </div>
      </div>
      <div className="formRow halfWidth">
        <TextBoxComponent placeholder="Mobiltelefon" floatLabelType="Always" {...register('contactMobilePhone')} />
      </div>
    </CustomCard>
  )
}
